import { Link } from "react-router";
import IconButton from "../IconButton/IconButton.jsx";
import styles from "./closeButton.css";

/**
 * Renders a close button wrapped in a link.
 * The color of the button is set by the parent element.
 *
 * @param {string} back - The path to navigate to when the button is clicked.
 * @param {string} ariaLabel - Description about what this button does; for screenreaders
 * @returns {JSX.Element} A link component containing an icon button with a "close" icon.
 */
export const CloseButton = ({ back = "..", ariaLabel = "Zurück" }) => (
  <Link
    to={back}
    aria-label={ariaLabel}
    className={styles.fitButtonHeight}
    id={"close-button"}
    replace
  >
    <IconButton name="xmark" theme={null} size="45px" />
  </Link>
);
